import React from 'react';
import { graphql } from 'gatsby';
import {
  StyledCards,
  StyledCard,
  StyledResourceCardType
} from './styles';
import Img from 'gatsby-image';
import { uid } from 'react-uid';
import SectionHeader from '../SectionHeader';
import Section from '../Section';
import SendGridLink from '../../SendGridLink';
import IconBook from '../../../assets/svg/icons/icon-book.svg';
import IconHeadset from '../../../assets/svg/icons/icon-headset.svg';

const GlobalContentBlocksResourcesPreviewBlock = ({ block }) => {
  const resources = block.resources.map((resource) => {
    // maps for resource type names and colors
    const mapTypeName = {
      BestPracticeGuides: {
        name: "Guide",
        lengthType: "read"},
      Webcasts: {
        name: "Webinar",
        lengthType: "video"},
    };
    const mapTypeColor = {
      Webinar: "#582DA4",
      Guide: "#008CFF"
    };
    const mapTypeCta = {
      Webinar: "Watch the webinar",
      Guide: "Read the guide",
      Report: "Read the report"
    };
    const mapTypeLengthNoun = {
      Webinar: "video",
      Guide: "read",
      Report: "read"
    };

    // initialize object to hold remapped resource object
    let remappedResource = {};    

    // define simple properies of remappped resource object
    remappedResource.title = resource.overrideResourceTitle ? resource.overrideResourceTitle : resource.resourceSource.title;
    remappedResource.excerpt = resource.overrideResourceExcerpt ? resource.overrideResourceExcerpt : resource.resourceSource.excerpt;
    remappedResource.uri = resource.overrideResourceLink ? resource.overrideResourceLink : resource.resourceSource.uri;
    remappedResource.featuredImage = resource.resourceSource.featuredImage ? resource.resourceSource.featuredImage.node : false;
    remappedResource.featuredImage = resource.overrideResourceImage ? resource.overrideResourceImage : remappedResource.featuredImage;

    // if resource length override is in place use that, otherwise try to use dynamic value from resource post, failing that set value to false
    if (resource.overrideResourceLength) {
      remappedResource.length = resource.overrideResourceLength;
    } else {
      remappedResource.length = resource.resourceSource.resourcesLength.length ? resource.resourceSource.resourcesLength.length : false;
    }

    // resource type takes name from post object's taxonomy term or if it is undefined, it is set to false, then if not false: check mapTypeName to see if we should update the name
    // resource type name override if user defined overrides in wp admin
    remappedResource.typeName = typeof resource.resourceSource.resourceTypes.nodes[0] !== "undefined" ? resource.resourceSource.resourceTypes.nodes[0].name : false;
    if (remappedResource.typeName){
      remappedResource.typeName = mapTypeName[`${remappedResource.typeName.replace(/\s/g, '')}.name`] ? mapTypeName[`${remappedResource.typeName.replace(/\s/g, '')}.name`] : remappedResource.typeName;
    }
    remappedResource.typeName = resource.overrideResourceTypeName ? resource.overrideResourceTypeName : remappedResource.typeName;

    // check map for associated color based on resource type, if no match then use default
    remappedResource.typeColor = mapTypeColor[`${remappedResource.typeName}`] ? mapTypeColor[`${remappedResource.typeName}`] : "#008CFF";

    remappedResource.typeCta = mapTypeCta[`${remappedResource.typeName}`] ? mapTypeCta[`${remappedResource.typeName}`] : "View resource";

    remappedResource.typeLengthNoun = mapTypeLengthNoun[`${remappedResource.typeName}`] ? mapTypeLengthNoun[`${remappedResource.typeName}`] : false;

    return remappedResource;
  });

  return (
      <Section theme="white">
        {console.log(block)}
        <SectionHeader tagline={block.headline} title={block.subheadline} marginBottomTablet={'68px'} marginBottomMobile={'68px'}/>
   
     
        {resources && (
            <StyledCards>            
              {resources.map((resource) => (
                <StyledCard key={uid(resource)}>
                  <div className="resource-card__image-container">
                    {resource.featuredImage && (
                      <Img fluid={resource.featuredImage.imageFile.childImageSharp.fluid} alt={resource.featuredImage.alt}/>
                    )}
                  </div>
                  <div className="resource-card__type-and-length">
                    {resource.typeName && (
                      <StyledResourceCardType color={resource.typeColor}>
                        {resource.typeName === "Webinar" && <IconHeadset className="resource-dot"/>}
                        {resource.typeName !== "Webinar" && <IconBook className="resource-dot"/>}
                        <div>
                          <span dangerouslySetInnerHTML={{ __html: resource.typeName }} />
                        </div>
                      </StyledResourceCardType>
                    )}
                    <div>
                    {resource.length && (
                      <span className="resource-card__length">
                        <span dangerouslySetInnerHTML={{ __html: resource.length }} />
                        &nbsp;min {resource.typeLengthNoun}
                      </span>
                    )}
                    </div>
                  </div>

                  <h2 dangerouslySetInnerHTML={{ __html: resource.title }} />
                  <div className="resource-card__excerpt" dangerouslySetInnerHTML={{ __html: resource.excerpt }} />
                  <div className="resource-card__cta-wrapper">
                    <SendGridLink
                      href={resource.uri}
                      className="arrow-link"
                      dangerouslySetInnerHTML={{ __html: resource.typeCta }}
                    />
                  </div>

                </StyledCard>
              ))}
            </StyledCards>
          )}

      </Section>
  );
};

export default GlobalContentBlocksResourcesPreviewBlock;

export const query = graphql`
  fragment ResourcesPreviewBlockFragment on WPGraphQL_Page {
    acfGlobalContentBlocks {
      contentBlocks {
        ... on WPGraphQL_Page_Acfglobalcontentblocks_ContentBlocks_ResourcesPreviewBlock {
          fieldGroupName
          headline
          subheadline
          resources {
            overrideResourceValues
            overrideResourceTypeName
            overrideResourceTitle
            overrideResourceExcerpt
            overrideResourceLength
            overrideResourceLink
            overrideResourceImage {
              altText
              sourceUrl
              imageFile {
                childImageSharp {
                  fluid(maxWidth: 460) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
            resourceSource {  
              ... on WPGraphQL_Resource {
                title
                excerpt
                uri
                resourcesLength {
                  length
                }
                resourceTypes {
                  nodes {
                    name
                  }
                }
                featuredImage {
                  node {
                    altText
                    sourceUrl
                    imageFile {
                      childImageSharp {
                        fluid(maxWidth: 460) {
                          ...GatsbyImageSharpFluid
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
